import { useRef, useEffect, useState } from "react";
import css2 from "../Form.module.css";
import css from "./Date.module.css";

const DateOnly = ({ children, onChange }) => {
    const dateRef = useRef();
    const { label, required, value, disabled } = children; 
    const [localValue, setLocalValue] = useState(value ? new Date(value) : null);

    useEffect(() => {
        setLocalValue(value ? new Date(value) : null);
    }, [value]);

    useEffect(() => {
        if (localValue) {
            const year = localValue.getFullYear();
            const month = String(localValue.getMonth() + 1).padStart(2, "0");
            const day = String(localValue.getDate()).padStart(2, "0");
            dateRef.current.value = `${year}-${month}-${day}`;
        } else {
            dateRef.current.value = "";
        }
    }, [localValue]);

    const valChange = () => {
        const date = dateRef.current.value;
        if (date) {
            const newDate = new Date(date);
        
            const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
            
            children.value = formattedDate;
            onChange && onChange(children);
        } else {
            children.value = null;
            onChange && onChange(children);
        }
    };

    return (
        <div className={css2.FormControl}>
            <label className={css.Label}>{label}</label>
            <div>
                <input
                    onChange={valChange}
                    ref={dateRef}
                    type="date"
                    required={required}
                    className={css.Input}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

export default DateOnly;